export const URL_FEATURED_ROUTE = 'featured';
export const URL_NEWLYADDED_ROUTE = 'newlyadded';
export const URL_GENRES_ROUTE = 'genres';
export const URL_ALLPRODUCTS_ROUTE = 'products';
